const DEFAULT_GTM_ID = "GTM-PXNFFPGS"

export const initGtm = (gtmId: string = DEFAULT_GTM_ID): void => {
    if (!gtmId) {
        return
    }

    const existing = document.getElementById("gtm-script")
    if (existing) {
        return
    }

    const w = window as Window & {
        dataLayer?: Array<Record<string, unknown>>
    }
    w.dataLayer = w.dataLayer || []
    w.dataLayer.push({
        "gtm.start": new Date().getTime(),
        event: "gtm.js",
    })

    const d = document
    const f = d.getElementsByTagName("script")[0]
    const j = d.createElement("script")
    const dl = "&l=dataLayer"
    j.id = "gtm-script"
    j.async = true
    j.src = `https://www.googletagmanager.com/gtm.js?id=${gtmId}${dl}`
    if (f?.parentNode) {
        f.parentNode.insertBefore(j, f)
    } else {
        d.head.appendChild(j)
    }
}
